import styles from "./vertical-separator.module.scss";

interface IProps {
  className?: string;
}

function VerticalSeparator(props: IProps) {
  const { className = "" } = props;
  return <div className={`${styles.vertical_separator} ${className}`} />;
}

export default VerticalSeparator;
